import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'relativeTime', standalone: true })
export class RelativeTimePipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value == null) return '';

    const diffMs = Date.now() - value;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHr / 24);
    const diffMonth = Math.floor(diffDay / 30);
    const diffYear = Math.floor(diffDay / 365);

    if (diffYear >= 1) return `пре ${diffYear} ${diffYear < 5 ? 'године' : 'година'}`;
    if (diffMonth >= 1) return `пре ${diffMonth} ${diffMonth < 5 ? 'месецa' : 'месеци'}`;
    if (diffDay >= 1) return `пре ${diffDay} дана`;
    if (diffHr >= 1) return `пре ${diffHr} ${diffHr < 5 ? 'сата' : 'сати'}`;
    if (diffMin >= 1) return `пре ${diffMin} минута`;
    return 'малопре';
  }
}
